import { render, staticRenderFns } from "./idpSSOConfigForm.vue?vue&type=template&id=2a606ae4&"
import script from "./idpSSOConfigForm.vue?vue&type=script&lang=js&"
export * from "./idpSSOConfigForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a606ae4')) {
      api.createRecord('2a606ae4', component.options)
    } else {
      api.reload('2a606ae4', component.options)
    }
    module.hot.accept("./idpSSOConfigForm.vue?vue&type=template&id=2a606ae4&", function () {
      api.rerender('2a606ae4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ugsrc/components/tenants/idpSSOConfigForm.vue"
export default component.exports